import { X } from 'lucide-react';
import { INVENTORY, TYPE_LABELS } from './data';

// Hidden staff overlay — dark monospace look, intentionally separate from
// the customer-facing brand surface.
const StaffPanel = ({ onClose }) => {
  const grouped = INVENTORY.reduce((acc, p) => {
    (acc[p.type] = acc[p.type] || []).push(p);
    return acc;
  }, {});

  return (
    <div className="fixed inset-0 bg-black/85 backdrop-blur-sm z-[100] flex items-stretch sm:items-center justify-center p-0 sm:p-8">
      <div
        className="bg-[#0a110e] border border-[#1f3d2b] w-full sm:max-w-4xl sm:max-h-[90vh] sm:rounded-3xl shadow-2xl flex flex-col overflow-hidden text-gray-300"
        style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
          <div>
            <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#86a892]">
              Staff Mode · Inventory
            </div>
            <h2 className="text-xl text-white font-bold mt-1">
              {INVENTORY.length} SKUs
            </h2>
          </div>
          <button
            data-testid="staff-panel-close"
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 active:bg-white/15 flex items-center justify-center text-gray-300 transition-colors"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-auto px-6 py-4">
          {Object.entries(grouped).map(([type, items]) => (
            <div key={type} className="mb-6">
              <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#7fb38a] mb-2">
                {TYPE_LABELS[type] || type}
              </div>
              <table className="w-full text-sm">
                <thead className="text-[10px] text-[#5a7062] uppercase tracking-widest">
                  <tr>
                    <th className="text-left font-semibold py-2 w-24">SKU</th>
                    <th className="text-left font-semibold py-2">Name</th>
                    <th className="text-right font-semibold py-2 w-20">Price</th>
                    <th className="text-right font-semibold py-2 w-12">Pri</th>
                    <th className="text-right font-semibold py-2 w-16">Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((p) => (
                    <tr key={p.sku} className="border-t border-white/5">
                      <td className="py-2 font-mono text-[#86a892]">{p.sku}</td>
                      <td className="py-2 text-gray-100">{p.name}</td>
                      <td className="py-2 text-right text-gray-300">
                        ${p.price.toFixed(2)}
                      </td>
                      <td className="py-2 text-right text-gray-400">{p.priority}</td>
                      <td className="py-2 text-right">
                        <span
                          className={`text-[10px] px-2 py-0.5 rounded-full font-bold uppercase tracking-wider ${
                            p.in_stock
                              ? 'bg-[#1f3d2b] text-[#a8d5b6]'
                              : 'bg-white/10 text-gray-500'
                          }`}
                        >
                          {p.in_stock ? 'In' : 'Out'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StaffPanel;
